import src from "IMAGE";
export default { src, width: 69, height: 58, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
